/**
 * Algeria-only mobile phone validation — Akram's explicit call (2026-08-29): "since we're sure
 * it's dz only for now, add algerian phone number regex and limitations".
 *
 * ⚠️ Scoped to Algeria ON PURPOSE, not derived from anything the round or the backend declares.
 * The backend's own check (`PHONE_RE` in `application_services.py`) is deliberately loose —
 * `^\+?[0-9 ()-]{8,20}$`, any plausible-looking international number — because it has no reason to
 * assume a single country. This file narrows that FURTHER, client-side only, for as long as the
 * pilot cohort is Algeria-only. If that changes, this file is what widens or goes — not the
 * backend's own contract.
 *
 * Matches a mobile number only (05/06/07), not landlines (02/03/04) — the field this backs
 * (`mobile_phone`) exists to arrange an interview call/SMS, and a landline can't receive either.
 * Accepts either the local form (`05XX XX XX XX`, 10 digits) or the international form
 * (`+213 5XX XX XX XX`), and tolerates the spaces/dashes a person naturally types — normalized
 * away before the pattern is tested, never required.
 */
const DZ_MOBILE_REGEX = /^(?:\+213|0)[5-7]\d{8}$/;

/** Strips everything but digits and a single leading `+`, so `05 51 23 45 67` and `05-51-23-45-67` validate the same as `0551234567`. */
function normalize(value: string): string {
  const trimmed = value.trim();
  const hasLeadingPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/[^0-9]/g, "");
  return hasLeadingPlus ? `+${digits}` : digits;
}

export function isValidDzMobilePhone(value: string): boolean {
  return DZ_MOBILE_REGEX.test(normalize(value));
}
